export default "__VITE_ASSET__b377b4cf__"